import { render, staticRenderFns } from "./AppMultipleImageUpload.vue?vue&type=template&id=c18d80f8&scoped=true&"
import script from "./AppMultipleImageUpload.vue?vue&type=script&lang=js&"
export * from "./AppMultipleImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./AppMultipleImageUpload.vue?vue&type=style&index=0&id=c18d80f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18d80f8",
  null
  
)

export default component.exports